import {
  Avatar,
  Box,
  Container,
  Flex,
  Heading,
  Icon,
  Text,
} from '@chakra-ui/react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Link, graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { StarIcon } from '@chakra-ui/icons';
import { generate } from 'shortid';
import { LinkOne } from '../_index';
import GoogleG from '../../assets/Google__G__Logo.svg';
import BBBSeal from '../../assets/Ab-bbb-seal-a.svg';

const ReviewCallout = () => {
  const { googleReviews, googleFiveStarImg, bbbFancy } = useStaticQuery(query);
  const image = getImage(bbbFancy);

  const review = googleReviews.nodes[Math.floor(Math.random() * googleReviews.nodes.length)];
  return (
    <Container
      maxW="container.lg"
      py={6}
    >
      <Box
        rounded="md"
        p={5}
        backgroundColor="white"
        boxShadow="xl"
        display="flex"
        flexDirection={{ base: 'column-reverse', md: 'row' }}
        alignItems="center"
      >
        <Box
          flexBasis={{ base: '100%', md: '30%' }}
          display="flex"
          flexDir="column"
          justifyContent="flex-end"
        >
          <Box
            display="flex"
            flexDir="row"
            width="200px"
            flexWrap="wrap"
            alignItems="center"
            justifyContent="space-around"
          >
            <a href="https://bbb.org/us/ca/fremont/profile/real-estate-investing/we-buy-houses-in-bay-area-1116-918740">
              <Box
                width="200px"
                my={6}
              >
                <GatsbyImage
                  alt="A plus Better Business Bureau"
                  image={image}
                />
              </Box>
            </a>
          </Box>
        </Box>
        <Box flexBasis={{ base: '100%', md: '70%' }}>
          <Box
            mb={3}
            display="flex"
            alignItems="center"
          >
            <Box mr={2}>
              <GoogleG />
            </Box>
            {Array.from({ length: review.rating }, () => 0).map((j) => (
              <Icon
                key={generate()}
                as={StarIcon}
                boxSize={6}
                color="yellow.300"
              />
            ))}
          </Box>
          <Text
            mb={4}
            fontSize="xl"
            as="em"
            noOfLines="5"
          >
            {review.text}
          </Text>
          <Heading
            as="h6"
            variant="sec"
            size="md"
          >
            -
            {' '}
            {review.author_name}
          </Heading>
          <Box mt={4}>
            <LinkOne to={`/reviews/#${review.googlePlacesId}`}>
              Read Full Review
            </LinkOne>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export const query = graphql`
  query {
    googleReviews: allGooglePlacesReview {
      nodes {
        author_url
        author_name
        googlePlacesId
        rating
        profile_photo_url
        time
        relative_time_description
        text
        id
      }
    }
    bbbFancy: file(relativePath: { eq: "fancy-bbb.png" }) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED)
      }
    }
    googleFiveStarImg: file(relativePath: { eq: "Google-5-Star.png" }) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED)
      }
    }
  }
`;

export default ReviewCallout;
